import { XAxis, YAxis } from 'recharts';

export function ChartAxes() {
  return (
    <>
      <XAxis
        dataKey="month"
        axisLine={false}
        tickLine={false}
        dy={10}
        tick={{ fill: '#6B7280', fontSize: 13 }}
      />
      <YAxis
        axisLine={false}
        tickLine={false}
        dx={-10}
        tick={{ fill: '#6B7280', fontSize: 13 }}
        width={60}
      />
    </>
  );
}